import Api_Usermanagement from '../../api-usermanagement'
import Api_Masterdata from '../../api-masterdata'
import Api_Masterdata_v2 from '../../api-masterdata-v2'

const api_masterdata = new Api_Masterdata().init()
const api_masterdata_v2 = new Api_Masterdata_v2().init()
const api = new Api_Usermanagement().init()

const getPriceAll = (page) => {
  return api_masterdata.get(`/price-list/dasar?per_page=${page}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getPriceAllSearch = (code, name, price) => {
  return api_masterdata.get(
    `/price-list/dasar?product_code=${code}&product_name=${name}&price=${price}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getAuditTrailSearch = (name, activ, date) => {
  return api.get(`/audit-trail?username=${name}&activities=${activ}&date=${date}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getPriceJbp = (type, page) => {
  return api_masterdata.get(`/price-list/jbp?type=${type}?per_page=${page}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const massUpdatePriceJbp = (type, data) => {
  return api_masterdata.patch(`/price-list/${type}/update-status`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getPriceJbpSearch = (
  type,
  sales,
  code,
  custCode,
  prodcode,
  prodName,
  region,
  city,
  status,
  sellPrice,
  dist,
  purPrice,
  page
) => {
  return api_masterdata.get(
    `/price-list/jbp?sales_org_code2=${code}&sales_org_code=${sales}&customer_code=${custCode}&product_code=${prodcode}&product_name=${prodName}&region_name=${region}&city_name=${city}&is_active=${status}&selling_price=${sellPrice}&discount=${dist}&purchase_price=${purPrice}&type=${type}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}
const getPriceJbpSearch2 = (
  type,
  sales,
  code,
  prodcode,
  productName,
  region,
  city,
  status,
  sellPrice,
  purPrice
) => {
  return api_masterdata.get(
    `/price-list/jbp?sales_org_code2=${code}&sales_org_code=${sales}&product_code=${prodcode}&product_name=${productName}&region_name=${region}&city_name=${city}&is_active=${status}&selling_price=${sellPrice}&purchase_price=${purPrice}&type=${type}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const detailPrice = (id) => {
  return api_masterdata.get(`/price-list/jbp/detail?id=${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getIncotermAll = () => {
  return api.get('/incoterm', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getAllIncoterms = () => {
  return api.get('/incoterm/get-all', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getTransport = () => {
  return api_masterdata.get('/transport-mode', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getErrorSAPList = () => {
  return api.get('/log/sales-order/flag-list', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getIncotermAllSearch = (code) => {
  return api.get(`/incoterm?code=${code}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getEndUSerAll = () => {
  return api_masterdata.get('/enduser', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getEndUSerAllSearch = (code, name, custCode, endcodeName) => {
  return api_masterdata.get(
    `/enduser?end_user_code=${code}&customer_name=${name}&name=${endcodeName}&customer_code=${custCode}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const detailEndUser = (id) => {
  return api_masterdata.get(`/enduser/detail?id=${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const createEndUser = (data) => {
  return api_masterdata.post(
    `/enduser/create?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const editEndUser = (id, data) => {
  return api_masterdata.put(
    `/enduser/edit/${id}?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const deleteEndUser = (id) => {
  return api_masterdata.delete(
    `/enduser/delete/${id}?credentials=${localStorage.getItem('credential')}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getTopAll = () => {
  return api.get('/term-of-payment', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getUserAll = () => {
  return api.get('/users', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getUserSearch = (name, user, email, role) => {
  return api.get(`/users?name=${name}&nama_pengguna=${user}&email=${email}&role_name=${role}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getUserDetail = (id) => {
  return api.get(`/users/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getRegionAll = () => {
  return api.get('/regions', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getRegionAllMasterData = () => {
  return api_masterdata.get('/regions', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getFilterCity = (id) => {
  return api.get(`/cities?regions=${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getFilterCityMasterData = (id) => {
  return api_masterdata.get(`/cities?regions=${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getJbpTypeMasterData = (sales_org) => {
  return api_masterdata_v2.get(`/price-list/jbp-type/list?company_code=${sales_org}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'X-Credentials': localStorage.getItem('credential'),
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getSalesOrgAll = () => {
  return api.get(`/sales-org`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getSalesOrgAllMasterData = () => {
  return api_masterdata.get(`/sales-org`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getRoleAll = () => {
  return api.get(`/role`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getRoleList = () => {
  return api.get(`/role/list`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getRoleFlagList = () => {
  return api.get(`/role/role-flag`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getRoleSearch = (name, sales) => {
  return api.get(`/role?name=${name}&sales_org_code=${sales}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getLevelAll = (id) => {
  return api.get(`/approval-level?sales_org_codes=${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getMenuAll = (id) => {
  return api.get(`/menu`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getMenuSearch = (name, parent, sort) => {
  return api.get(`/menu?name=${name}&parent=${parent}&sort=${sort}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getParentAll = (id) => {
  return api.get(`/menu/parent`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getDetailRole = (id) => {
  return api.get(`/role/detail/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getDetailMenu = (id) => {
  return api.get(`/menu/detail/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getDetailJbpType = (id) => {
  return api_masterdata_v2.get(`/price-list/jbp-type/detail/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'X-Credentials': localStorage.getItem('credential'),
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getDetailIncoterm = (id) => {
  return api.get(`/incoterm/detail/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getDetailTransport = (id) => {
  return api_masterdata.get(`/transport-mode/detail/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getDetaildasar = (id) => {
  return api_masterdata.get(`/price-list/dasar/detail/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getPricelistImport = (lang, data, credential) => {
  return api_masterdata.post(
    `/price-list/dasar/import?lang=${lang}&credentials=` + credential,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getPricelistBJBImport = (lang, data, credential) => {
  return api_masterdata.post(`/price-list/jbp/import?lang=${lang}&credentials=` + credential, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getPricelistBJBImportV2 = (lang, data, credential) => {
  return api_masterdata_v2.post(`/price-list/jbp-config/import?lang=${lang}&credentials=` + credential, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const bjpPriceImportV2 = (lang, data, credential) => {
  return api_masterdata_v2.post(`/price-list/pricing/import?lang=${lang}&credentials=` + credential, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getPricelistImportTemplate = (data) => {
  return api_masterdata.get(`/price-list/dasar/import/template`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getDetailJbp = (id) => {
  return api_masterdata.get(`/price-list/jbp/detail?id=${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getDetailJbpConfig = (id) => {
  return api_masterdata_v2.get(`/price-list/jbp-config/detail/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getDetailJbpPricing = (mode, id) => {
  return api_masterdata_v2.get(`/price-list/pricing/detail/${id}/${mode}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getDetailTracking = (id) => {
  return api.get(`/tracking-order?order_sub_detail_id=${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getDo = () => {
  return api.get(`/delivery-order`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getSectorList = () => {
  return api.get(`/sector/list`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getAuditAll = () => {
  return api.get(`/audit-trail`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getAccess = (id) => {
  return api.get(`/role-access/access/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getNewsAll = () => {
  return api.get(`/news`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getNewsSearch = (title, content, flag, url) => {
  return api.get(`/news?title=${title}&content=${content}&flag=${flag}&url=${url}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getNewsDetail = (id) => {
  return api.get(`/news/detail/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getLevelList = (id) => {
  return api.get(`/user-level/list`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getIcon = (id) => {
  return api.get(`/icon`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getByProduct = (id) => {
  return api_masterdata.get(`/price-list/dasar/product-code/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getUserLevelSorg = (id) => {
  return api.get(`/user-level/list?sales_org_code=${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getBankAll = () => {
  return api_masterdata.get(`/bank/bank-account`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getBankList = () => {
  return api_masterdata.get(`/bank/list`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getBankDetail = (id) => {
  return api_masterdata.get(`/bank/bank-account/detail?id=${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getBankSearch = (bank, salesOrg, bankAcc, bankGl, bankClear, status) => {
  return api_masterdata.get(
    `/bank/bank-account?bank=${bank}&sales_org_code=${salesOrg}&bank_account=${bankAcc}&bank_gl_account=${bankGl}&bank_clearing_acct=${bankClear}&status=${status}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getSalesOrg = () => {
  return api.get(`/sales-org`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getSalesAreaKontrak = (distribution_channel, sales_org) => {
  return api_masterdata.get(
    `/sales-area-assignment/list?division=ZZ&distribution_channel=${distribution_channel}&sales_org=${sales_org}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getCusGrup = (sector = '') => {
  return api.get(`/customer-account-group/list?sector_id=${sector}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getAccAss = () => {
  return api.get(`/account-assignment-group/list`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getAccAssSO = (head = 0, code = '') => {
  return api.get(
    `/customer-assignment/list?customer_head=${head}&customer_account_group_code=${code}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getConfigLetter = (sales, module) => {
  return api.get(`/config/letter/get?sales_org_code=${sales}&module=${module}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getBatasTanggalLetter = (quantum, sales, lang, sector) => {
  return api.get(
    `/config/date-config/latest-pickup-date?total_quantum_so=${quantum}&sales_org_code=${sales}&sector_id=${sector}&lang=${lang}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const putUpdateProfile = (data) => {
  return api.put(`/users/update-profile`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const exportData = (filter) => {
    const queryString = new URLSearchParams(filter).toString();
    return api_masterdata_v2.get(`/price-list/jbp-config/export?${queryString}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    })
}

export {
  getPriceAll,
  getPriceJbp,
  getAuditTrailSearch,
  getIncotermAll,
  getEndUSerAll,
  detailEndUser,
  createEndUser,
  editEndUser,
  deleteEndUser,
  getTopAll,
  getUserAll,
  getRegionAll,
  getFilterCity,
  getSalesOrgAll,
  getRoleAll,
  getLevelAll,
  getParentAll,
  getMenuAll,
  getDetailRole,
  getDetailMenu,
  getDetailIncoterm,
  getDetaildasar,
  getDetailJbp,
  getDetailTracking,
  getDo,
  getSectorList,
  getUserDetail,
  getAuditAll,
  getAccess,
  getNewsAll,
  getNewsDetail,
  getLevelList,
  getNewsSearch,
  getAllIncoterms,
  getPriceAllSearch,
  getPriceJbpSearch,
  getIncotermAllSearch,
  getEndUSerAllSearch,
  getIcon,
  getPricelistImport,
  getByProduct,
  getUserLevelSorg,
  getPricelistImportTemplate,
  getBankAll,
  getBankList,
  getBankDetail,
  getUserSearch,
  getRoleSearch,
  getMenuSearch,
  getBankSearch,
  getSalesOrg,
  getRoleList,
  getPricelistBJBImport,
  getSalesAreaKontrak,
  getCusGrup,
  getAccAss,
  getJbpTypeMasterData,
  massUpdatePriceJbp,
  detailPrice,
  getPriceJbpSearch2,
  getAccAssSO,
  getTransport,
  getDetailTransport,
  getSalesOrgAllMasterData,
  getRegionAllMasterData,
  getFilterCityMasterData,
  getConfigLetter,
  getBatasTanggalLetter,
  getRoleFlagList,
  getDetailJbpPricing,
  putUpdateProfile,
  getDetailJbpType,
  getPricelistBJBImportV2,
  getDetailJbpConfig,
  bjpPriceImportV2,
  getErrorSAPList,
  exportData
}
